import {
    compose,
    filter,
    compact,
    sortBy,
    map,
    isNil,
    isArray,
    isEmpty,
    entries,
    isNumber,
    isNaN,
    isString,
    getOr,
} from 'lodash/fp';
import { PureComponent } from 'react';
import { alpha } from '@optimus-web/core';
import {
    TooltipMarkElement,
    TooltipElement,
    TooltipItemElement,
    TooltipItemNameElement,
    TooltipLabelElement,
} from './style';

const isNumOrStr = (value: $TSFixMe) => (isNumber(value) && !isNaN(value)) || isString(value);

const defaultFormatter = (value: $TSFixMe) =>
    isArray(value) && isNumOrStr(value[0]) && isNumOrStr(value[1]) ? value.join(' ~ ') : value;

interface OwnTooltipContentProps {
    formatter?: $TSFixMeFunction;
    labelFormatter?: $TSFixMeFunction;
    label?: string;
    payload?: {
        name?: $TSFixMe;
        value?: number | string | $TSFixMe[];
        unit?: $TSFixMe;
    }[];
    itemSorter?: $TSFixMeFunction;
    itemFilter?: $TSFixMeFunction;
}

type TooltipContentProps = OwnTooltipContentProps & typeof TooltipContent.defaultProps;

class TooltipContent extends PureComponent<TooltipContentProps> {
    static displayName = 'TooltipContent';

    static defaultProps = {
        itemFilter: () => true,
    };

    renderContent() {
        const { payload, formatter, itemSorter, itemFilter } = this.props;

        if (payload && payload.length) {
            const items = compose(
                entries,
                // @ts-expect-error $TSFixMeError: Argument of type '$TSFixMeFunction | undefined' is not assignable to parameter of type 'Many<ValueIteratee<any>>'.
                sortBy(itemSorter),
                filter(itemFilter),
                filter((entry) => !(isArray((entry as $TSFixMe).value) && isEmpty(compact((entry as $TSFixMe).value)))),
                filter((entry) => !isNil((entry as $TSFixMe).value))
            )(payload);

            const mappedItems = map(([i, entry]) => {
                const hasName = isNumOrStr(entry.name);
                const finalFormatter = entry.formatter || formatter || defaultFormatter;
                const markColor = alpha(entry.color, getOr(1, 'fillOpacity', entry));

                return (
                    <TooltipItemElement key={`tooltip-item-${entry.dataKey}`} color={entry.color}>
                        <TooltipMarkElement color={markColor} />
                        {hasName ? <TooltipItemNameElement>{entry.name}</TooltipItemNameElement> : null}
                        <strong>
                            {finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value}
                        </strong>
                        <strong>{entry.unit || ''}</strong>
                    </TooltipItemElement>
                );
            })(items);

            return <div>{mappedItems}</div>;
        }

        return null;
    }

    render() {
        const { label, labelFormatter } = this.props;
        const hasLabel = isNumOrStr(label);
        let finalLabel = hasLabel ? label : '';

        if (hasLabel && labelFormatter) {
            finalLabel = labelFormatter(label);
        }

        return (
            <TooltipElement>
                <TooltipLabelElement>{finalLabel}</TooltipLabelElement>
                {this.renderContent()}
            </TooltipElement>
        );
    }
}

export default TooltipContent;
